export * as Cache from "./Cache";
export * as SharedState from "./SharedState";
export * as Stream from "./Stream";
export * as Store from "./Store";
export * from "./Remote";

export namespace ID {
  export type ID = string;
}

export namespace Reference {
  export type Reference = { readonly id: ID.ID };

  export namespace Get {
    export type When<A, B> = Partial<Reference> & {
      readonly missing: () => B;
      readonly found: (a: A) => B;
    };
  }
}
